var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeploy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8647 2.5293C63.6118 1.77051 62.9795 1.13818 62.2207 0.885254C58.1738 0 55.0122 0 51.8506 0C38.8247 0 30.9839 7.08203 25.1665 16.1875H11.8877C9.86426 16.314 7.46143 17.7051 6.44971 19.6021L0.25293 32.1221C0.126465 32.5015 0 33.0073 0 33.3867C0 35.1572 1.26465 36.4219 3.03516 36.4219H16.061L13.2788 39.3306C11.7612 40.7217 11.6348 43.3774 13.2788 45.0215L19.7285 51.4712C21.1196 52.8623 23.7754 53.1152 25.4194 51.4712L28.2017 48.689V61.7148C28.3281 63.4854 29.5928 64.75 31.3633 64.75C31.7427 64.75 32.2485 64.6235 32.6279 64.4971L45.1479 58.3003C47.0449 57.2886 48.436 54.8857 48.436 52.8623V39.5835C57.668 33.7661 64.6235 25.9253 64.6235 12.8994C64.75 9.73779 64.75 6.57617 63.8647 2.5293ZM48.5625 21.2461C45.6538 21.2461 43.5039 19.0962 43.5039 16.1875C43.5039 13.4053 45.6538 11.1289 48.5625 11.1289C51.3447 11.1289 53.6211 13.4053 53.6211 16.1875C53.6211 19.0962 51.3447 21.2461 48.5625 21.2461Z",
    fill: "#045091"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeploy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deploy.449ddec5.svg";
export { ForwardRef as ReactComponent };